import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HoverTooltipAnimations } from './hover-tooltip.animations';

@Component({
  selector: 'pc-hover-tooltip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hover-tooltip.component.html',
  styleUrl: './hover-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [HoverTooltipAnimations]
})
export class HoverTooltipComponent {
  tooltipText = input.required<string>();
  tooltipWidth = input<string>('');
}
